import React, { Component } from 'react';
import { getCBTScore, getUserStatsByTestId } from '../services';
import CBTTestTimeTaken from './CBTTestTimeTaken';
import CBTTotalScore from './CBTTotalScore';
export default class FinishPageRightSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userTime: 0,
      userStatsData: {},
      score: 0,
    };
  }
  componentDidMount = async () => {
    const { testId, mockId } = this.props.params;
    const data = {
      test_id: testId,
      mock_id: mockId,
    };

    this.getUserStats(data);
    this.getCBTAnsweredCount(data);
  };

  getUserStats = async data => {
    const result = await getUserStatsByTestId(data);

    if (result.success) {
      const { userStatsData } = result;
      this.setState({
        userTime: userStatsData.user_time_value,
        userStatsData,
        // score: userStatsData.score,
      });
    }
  };

  getCBTAnsweredCount = async data => {
    const result = await getCBTScore(data);
    if (result.success) {
      const { totalScore } = result;
      this.setState({ score: totalScore });
      this.props.getScore(totalScore || 0);
    }
  };

  render() {
    const { className } = this.props;
    const { userTime, userStatsData, score } = this.state;
    return (
      <div className={className}>
        <CBTTotalScore {...this.props} userStatsData={userStatsData} rightAnswerCount={score} />
        <CBTTestTimeTaken {...this.props} userTime={userTime} userStatsData={userStatsData} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ESG/CBT/FinishPageRightSidebar.jsx